import {
  Col,
  Row,
  Form,
  Input,
  Button,
  Select,
  message,
  DatePicker,
  Radio,
  Collapse,
  Divider,
  Modal,
  Upload,
  Spin,
  Table,
} from "antd";
import { useForm } from "antd/es/form/Form";
import React, { useEffect, useState } from "react";
import PhoneNumber from "../../../components/common/common/phoneNo";
import QualificationEdit from "./QualificationEdit";
import OtherDetailEdit from "./OtherDetailEdit";
import AdditionalDetailEdit from "./AdditionalDetailEdit";
import JobPositionCard from "../../../components/common/campaign/JobPositionCard";
import { useNavigate, useParams } from "react-router-dom";
import API_MANAGER from "../../../API";
import moment from "moment";
import DocumentBox from "../../../components/common/DocumentBox";
import EditCandidateIcon from "../../../Assets/editCandidateIcon.svg";
import DeleteIcon from "../../../Assets/delete.svg";
import { EditFilled, UploadOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import axios from "axios";
import { s3PreUrl } from "../../../constants/index";
import AddQualification from "./AddQualification";
import AddDocuments from "./AddDocuments";
import AddExperience from "./AddExperience";
import MedicalAssessmentEdit from "./MedicalAssessmentEdit";
import PoliceClearanceEdit from "./PoliceClearanceEdit";
import TelegramIcon from "../../../Assets/telegramIcon.png";
import GreenTick from "../../../Assets/client/GreenTracker.svg";
import RedCross from "../../../Assets/client/RedTracker.svg";
import Thumbnail from "../../../Assets/thumbnail.jpeg";

const { TextArea } = Input;

function CandidateEdit() {
  const [personalForm] = useForm();
  const [locationForm] = useForm();
  const [resumeForm] = useForm();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [discipline, setDisciplines] = useState([]);
  const [ethnicity, setEthnicity] = useState([]);
  const [industry, setIndustry] = useState([]);
  const [induction, setInduction] = useState([]);
  const [skills, setSkills] = useState([]);
  const [resumeEdit, setResumeEdit] = useState(false);
  const [qualificationEdit, setQualificationEdit] = useState(false);
  const [qualificationData, setQualificationData] = useState({});
  const [qualification, setQualification] = useState([]);
  const [licenceType, setLicenceType] = useState([]);
  const [classData, setClassData] = useState([]);
  const [conditions, setConditions] = useState([]);
  const [citizen, setCitizen] = useState("australian");
  const [data, setData] = useState({});
  
  const [type, setType] = useState("PD");
  const [otherDetailEdit, setOtherDetailEdit] = useState(false);
  const [resumeUpload, setResumeUpload] = useState(false);
  const [resumeFileList, setResumeFileList] = useState([]);
  const [additionalEdit, setAdditionalEdit] = useState(false);
  const [otherDocumentData, setOtherDocumentData] = useState({});
  const [certifyingAuthority, setCertifyingAuthority] = useState([]);
  const [fundName, setFundName] = useState([]);
  const [stateTags, setStateTags] = useState([]);
  const [expEdit, setExpEdit] = useState(false);
  const [jobTitle, setJobTitle] = useState([]);
  const [addQualification, setAddQualification] = useState(false);
  const [addDocument, setAddDocument] = useState(false);
  const [addExperience, setAddExperience] = useState(false);
  const [medicalAssessmentEdit, setMedicalAssessmentEdit] = useState(false);
  const [medicalAssessmentData, setMedicalAssessmentData] = useState({});
  const [medicalAssessmentTypes, setMedicalAssessmentTypes] = useState([]);
  const [policeClearanceEdit, setPoliceClearanceEdit] = useState(false);
  const [policeClearanceData, setPoliceClearanceData] = useState({});
  const [visaTypeNo, setVisaTypeNo] = useState([]);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [deleteType, setDeleteType] = useState(null);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [deleteCandidateId, setDeleteCandidateId] = useState(null);
  const [deleteUserId, setDeleteUserId] = useState(null);
  const [deleteIsVisa, setDeleteIsVisa] = useState(false);
  const [idType, setIdType] = useState([]);
  const [availability, setAvailability] = useState([]);
  const [citizenshipEditModalVisible, setCitizenshipEditModalVisible] = useState(false);
  const [selectedCitizenship, setSelectedCitizenship] = useState(null);
  const [shirt, setShirt] = useState([]);
  const [pants, setPants] = useState([]);
  const [boots, setBoots] = useState([]);
  const [nextOfKinRelation, setNextOfKinRelation] = useState([]);
  const [visible, setVisible] = useState(false);
  const [verifyData, setVerifyData] = useState({});
  const [verifyType, setVerifyType] = useState("");
  const [notify, setNotify] = useState(false);
  const [ticketType, setTicketType] = useState(null);
  const [ticketId, setTicketId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form1] = Form.useForm();
  const [commData, setCommData] = useState([]);
  const navigate = useNavigate();
  const renderPickValue = (value) => {
    if (value && typeof value === "object") {
      return value?.name || value?.correspondingValue || "-";
    }
    return value || "-";
  };
  const getLicenceNo = (e) => {
    return e?.documentData?.licenceNumber
      ? e?.documentData?.licenceNumber
      : e?.documentData?.licenseNumber;
  };
  const props = {
    name: "file",
    accept: "image/jpeg,image/jpg,.pdf",
    multiple: false,
    customRequest({ onSuccess }) {
      setTimeout(() => {
        onSuccess("ok");
      }, 0);
    },
    onChange(info) {
      const { status } = info.file;
      if (status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (status === "done") {
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
  };
  const onFinish = async (values) => {
    // This function only runs if validation passes
    // If validation fails, onFinishFailed will be called instead
    console.log("values", values);
    setLoading(true);
    try {
      values.userId = data._id;
      if (type === "PD") {
        values.phoneNumber = `${values.phoneNumber}`;
      }
      await API_MANAGER.editCandidatePersonalDetails(values);
      message.success("Successfully edited personal details");
      getData(); // Refresh data to show updated values
    } catch (error) {
      // This is a backend error
      message.error(error?.response?.data?.message?.message);
    }
    setLoading(false);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Form validation failed:', errorInfo);
    console.log('Error fields:', errorInfo.errorFields);
    // The validation messages will automatically appear below the fields
    // No API call will be made
    message.error('Please fill in all mandatory fields');
  };
  const onResumeFinish = async (values) => {
    setLoading(true);
    try {
      let resumeUrl = null;
      
      if (resumeFileList?.length > 0 && resumeFileList[0]?.originFileObj) {
        const dataResume = {
          extension: resumeFileList[0]?.type.split("/")[1],
          type: "DOCUMENT",
          name: resumeFileList[0].originFileObj.name,
          contentType: resumeFileList[0]?.type,
        };
        const responseResume = await API_MANAGER.fileUpload(dataResume);
        if (!responseResume?.data?.data?.url) {
          throw new Error("Failed to get upload URL");
        }
        await axios.put(
          responseResume?.data?.data?.url,
          resumeFileList[0]?.originFileObj
        );
        resumeUrl = s3PreUrl + responseResume.data?.data?.key;
      } else {
        resumeUrl = data?.candidate?.resume?.length > 0
          ? data?.candidate?.resume[0]?.resume
          : null;
      }
      
      if (!data?.candidate?.userId) {
        throw new Error("User ID not found");
      }
      
      const resumeData = {
        location: null,
        userId: data?.candidate?.userId,
        resume: resumeUrl,
        description: values.description || data?.candidate?.profileSummary || "",
        introVideo: data?.candidate?.introVideo || null,
      };
      
      const hasExistingResume = data?.candidate?.resume?.length > 0 && data?.candidate?.resume[0]?._id;
      
      if (hasExistingResume) {
        await API_MANAGER.editCandidateResume(
          resumeData,
          data?.candidate?.resume[0]._id
        );
        message.success("Successfully updated resume");
      } else {
        await API_MANAGER.uploadCandidateResume(resumeData);
        message.success("Successfully uploaded resume");
      }
      
      setResumeFileList([]);
      setResumeUpload(false);
      setResumeEdit(false);
      getData();
    } catch (error) {
      console.error("Resume upload error:", error);
      const errorMessage = error?.response?.data?.message?.message 
        || error?.response?.data?.message
        || error?.message 
        || "Failed to upload resume. Please try again.";
      message.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };
  const handleResume = ({ fileList: newFileList }) => {
    setResumeFileList(newFileList);
  };
  const handleQualificationEdit = () => {
    setQualificationEdit(!qualificationEdit);
  };
  const handleOtherDetailEdit = () => {
    setOtherDetailEdit(!otherDetailEdit);
  };

  const setFields = () => {
    personalForm.setFieldsValue({
      name: data?.candidate?.name,
      email: data?.candidate?.email,
         dob: data?.candidate?.dob ? dayjs(data.candidate.dob) : null,

      phoneNumber: data?.candidate?.phoneNumber,
      countryCode: `+${data?.candidate?.countryCode}`,
      gender: data?.candidate?.gender,
      ethnicity: data?.candidate?.ethnicity?.id,
      discipline: data?.candidate?.discipline?.id,
      isAvailable: data?.candidate?.isAvailable,
      availabilityDetails: data?.candidate?.availabilityDetails?.id,
      nextOfKinName: data?.candidate?.nextOfKinName,
      nextOfKinEmail: data?.candidate?.nextOfKinEmail,
      nextOfKinRelation: data?.candidate?.nextOfKinRelation?.id,
    });
    locationForm.setFieldsValue({
      location: data?.candidate?.location,
      street: data?.candidate?.street,
      city: data?.candidate?.city,
      state: data?.candidate?.state,
      country: data?.candidate?.country,
      postalCode: data?.candidate?.postalCode,
    });
    resumeForm.setFieldsValue({
      description: data?.candidate?.profileSummary,
    });
  };
  const getTags = async (type, setData) => {
    try {
      const response = await API_MANAGER.getPickListTags({
        type,
        limit: 2000,
        sort: "name",
      });
      setData(response?.data?.data?.tags);
    } catch (error) {
      message.error("Something went wrong");
    }
  };
  const getData = async () => {
    try {
      const response = await API_MANAGER.getCandidateDetail(id);
      const documents = response?.data?.data?.candidate?.documents;
      const hasVisaDocument = documents?.some(
        (doc) => doc?.documentType?.name === "VISA"
      );
      setCitizen(hasVisaDocument ? "non_australian" : "australian");
      const candidateData = response.data.data;
      if (candidateData?.candidate?.qualifications) {
        const uniqueQualifications = candidateData.candidate.qualifications.filter((qual, index, self) =>
          index === self.findIndex((q) => q._id === qual._id || (q.id === qual.id && q.id))
        );
        candidateData.candidate.qualifications = uniqueQualifications;
      }
      setData(candidateData);
      console.log(response.data.data,"LSSLL");
      console.log("otherDetails:", candidateData?.candidate?.otherDetails);
    } catch {
      message.error("Something went wrong");
    }
  };
  const handleVerified = async (e, type) => {
    setVerifyData(e);
    setVerifyType(type);
    setVisible(true);
  };

  const handleVerifyByModal = async () => {
    setLoading(true);
    const validate = {
      profileId: verifyData?.profileId,
      id: verifyData?.id,
      isVerified: true,
    };
    try {
      if (verifyType === "SOA" || verifyType === "VOC") {
        const params = {
          profileId: verifyData?.profileId,
          isValidate: true,
          docType: verifyType,
        };
        await API_MANAGER.verifySoaVocDocument(params, verifyData?.id);
      } else if (verifyType === "medical") {
        await API_MANAGER.verifyMedicalDocument(validate);
      } else if (verifyType === "police_clearence") {
        await API_MANAGER.verifyPoliceDocument(
          { isValidate: true },
          verifyData?.id
        );
      } else if (verifyType === "qualification") {
        await API_MANAGER.verifyQualificationDocument(
          {
            isValidate: true,
          },
          verifyData?.id
        );
      } else {
        await API_MANAGER.verifyDocument(validate);
      }
      message.success("Document Verified!");
      getData();
      setVisible(false);
    } catch (err) {
      message.error("Facing some issues!");
      setVisible(false);
    }
    setLoading(false);
  };

  const handleNotify = async (values) => {
    try {
      values.profileId = data.candidate._id;
      values.type = "CUSTOM";
      values.ticketType = ticketType;
      values.ticketId = ticketId;
      await API_MANAGER.sendNotification(values);
      form1.resetFields();
      setTicketType(null);
      setTicketId(null);
      getData();
      setNotify(false);
      message.success("Successfully sent notification");
    } catch {
      message.error("Something went wrong!");
    }
  };

  const handleOpen = () => {
    setIsModalOpen(true);
  };

  const handleClose = () => {
    setIsModalOpen(false);
  };
  
  
  
  const CommunicationsColumns = [
    {
      title: "No.",
      dataIndex: "si",
      width: "80px",
      render: (_, row, index) => {
        return (
          <span
            className="cursor-pointer"
            onClick={() => {
              navigate("/support/support-detail", {
                state: {
                  item: {
                    name: data?.candidate?.name,
                    contactedBy: "RECRUITER",
                    email: data?.email,
                    countryCode: data?.candidate?.countryCode,
                    phoneNumber: data?.candidate?.phoneNumber,
                    subject: row?.subject,
                    summary: row?.summary,
                    repliedTo: row?.repliedTo,
                    date: row?.createdAt,
                  },
                },
              });
            }}
          >
            {10 * (1 - 1) + index + 1}
          </span>
        );
      },
    },
    {
      title: "Subject",
      dataIndex: "subject",
      key: "subject",
      render: (_, row) => {
        return (
          <span
            className="cursor-pointer"
            onClick={() => {
              navigate("/support/support-detail", {
                state: {
                  item: {
                    name: data?.candidate?.name,
                    contactedBy: "RECRUITER",
                    email: data?.email,
                    countryCode: data?.candidate?.countryCode,
                    phoneNumber: data?.candidate?.phoneNumber,
                    subject: row?.subject,
                    summary: row?.summary,
                    repliedTo: row?.repliedTo,
                    date: row?.createdAt,
                  },
                },
              });
            }}
          >
            {row?.subject?.name}
          </span>
        );
      },
    },
    {
      title: "Message",
      dataIndex: "summary",
      key: "summary",
      render: (_, row) => {
        return (
          <span
            className="cursor-pointer"
            onClick={() => {
              navigate("/support/support-detail", {
                state: {
                  item: {
                    name: data?.candidate?.name,
                    contactedBy: "RECRUITER",
                    email: data?.email,
                    countryCode: data?.candidate?.countryCode,
                    phoneNumber: data?.candidate?.phoneNumber,
                    subject: row?.subject,
                    summary: row?.summary,
                    repliedTo: row?.repliedTo,
                    date: row?.createdAt,
                  },
                },
              });
            }}
          >
            {row?.summary?.substring("0", "120")}
          </span>
        );
      },
    },
    {
      title: "Replied",
      dataIndex: "repliedTo",
      key: "repliedTo",
      align: "center",
      render: (text, row) => {
        return (
          <span
            className="cursor-pointer"
            onClick={() => {
              navigate("/support/support-detail", {
                state: {
                  item: {
                    name: data?.candidate?.name,
                    contactedBy: "RECRUITER",
                    email: data?.email,
                    countryCode: data?.candidate?.countryCode,
                    phoneNumber: data?.candidate?.phoneNumber,
                    subject: row?.subject,
                    summary: row?.summary,
                    repliedTo: row?.repliedTo,
                    date: row?.createdAt,
                  },
                },
              });
            }}
          >
            <span>{<img src={row.repliedTo ? GreenTick : RedCross} />}</span>
          </span>
        );
      },
    },
    {
      title: "Date",
      dataIndex: "createdAt",
      key: "createdAt",
      width: "15%",
      render: (text, row) => {
        return (
          <span
            className="cursor-pointer"
            onClick={() => {
              navigate("/support/support-detail", {
                state: {
                  item: {
                    name: data?.candidate?.name,
                    contactedBy: "RECRUITER",
                    email: data?.email,
                    countryCode: data?.candidate?.countryCode,
                    phoneNumber: data?.candidate?.phoneNumber,
                    subject: row?.subject,
                    summary: row?.summary,
                    repliedTo: row?.repliedTo,
                    date: row?.createdAt,
                  },
                },
              });
            }}
          >
            <span>{moment(row.createdAt).format("DD-MM-YYYY")}</span>
          </span>
        );
      },
    },
  ];
  
  const notificationColumn = [
    {
      title: "No.",
      dataIndex: "si",
      width: "80px",
      render: (_, row, index) => {
        return <span>{10 * (1 - 1) + index + 1}</span>;
      },
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
    },
    {
      title: "Message",
      dataIndex: "message",
      key: "message",
      render: (text, row) => {
        return (
          <span
            style={{
              display: "flex",
              flexWrap: "wrap",
              wordBreak: "break-word",
            }}
          >
            {row.message}
          </span>
        );
      },
    },
    {
      title: "Read",
      dataIndex: "isRead",
      key: "isRead",
      align: "center",
      render: (text, row) => {
        return (
          <span>
            <span>{<img src={row.isRead ? GreenTick : RedCross} />}</span>
          </span>
        );
      },
    },
    {
      title: "Date",
      dataIndex: "createdAt",
      key: "createdAt",
      width: "15%",
      render: (text, row) => {
        return (
          <span>
            <span>{moment(row.createdAt).format("DD-MM-YYYY")}</span>
          </span>
        );
      },
    },
  ];
  
  const getCommunications = async () => {
    try {
      const response = await API_MANAGER.getContactById(
        { contactedBy: "CANDIDATE" },
        id
      );
      setCommData(response?.data?.data);
    } catch {
      message.error("Something went wrong");
    }
  };
  
  // Deduplicate experiences by _id or id before processing
  const uniqueExperiences = data?.candidate?.experiences?.filter((exp, index, self) => {
    const expId = exp._id || exp.id;
    return index === self.findIndex((e) => (e._id || e.id) === expId);
  }) || [];
  
  let arr = [];
  let currentRole = [];
  uniqueExperiences.forEach((item) => {
    if (item.currentRole === true) {
      currentRole.push(item);
    } else {
      arr.push(item);
    }
  });
  console.log("availability", availability);
  let profExp = [...currentRole, ...arr];
  useEffect(() => {
    getTags("DISCIPLINE", setDisciplines);
    getTags("ETHNICITY", setEthnicity);
    getTags("INDUSTRY", setIndustry);
    getTags("INDUCTION", setInduction);
    getTags("SKILL", setSkills);
    getTags("QUALIFICATION", setQualification);
    getTags("LICENCETYPE", setLicenceType);
    getTags("LICENCE_CLASS", setClassData);
    getTags("LICENCE_CONDITION", setConditions);
    getTags("CERTIFYING_AUTHORITY", setCertifyingAuthority);
    getTags("JOBTITLE", setJobTitle);
    getTags("FUND_NAME", setFundName);
    getTags("STATE", setStateTags);
    getTags("ID_TYPE", setIdType);
    getTags("VISA", setVisaTypeNo);
    getTags("AVAILABILITY", setAvailability);
    getTags("SHIRT", setShirt);
    getTags("PANTS", setPants);
    getTags("BOOTS", setBoots);
    getTags("MEDICAL_ASSESSMENT", setMedicalAssessmentTypes);
    getTags("RELATION", setNextOfKinRelation);
  }, []);
  useEffect(() => {
    getData();
    getCommunications();
  }, [
    resumeEdit,
    expEdit,
    qualificationEdit,
    otherDetailEdit,
    additionalEdit,
    addDocument,
    addExperience,
    medicalAssessmentEdit,
    policeClearanceEdit,
  ]);

  // Refresh data when switching tabs to ensure updated values are displayed
  useEffect(() => {
    if (Object.keys(data).length > 0) {
      getData();
    }
  }, [type]);

  useEffect(() => {
    if (Object.keys(data).length > 0) {
      setFields();
    }
  }, [data]);

  return (
    <>
      <div style={{ marginTop: "20px" }}>
        <Row className="professional_detail_container">
          <Col className="radioButtons">
            <Radio.Group
              defaultValue={type}
              onChange={(e) => setType(e?.target?.value)}
            >
              <Radio.Button value="PD">Personal Details</Radio.Button>
              <Radio.Button value="LT">Location</Radio.Button>
              <Radio.Button value="PE">Professional Experience</Radio.Button>
              <Radio.Button value="QT">Qualification</Radio.Button>
              <Radio.Button value="OD">Other Details</Radio.Button>
              <Radio.Button value="CM">Communication</Radio.Button>
              <Radio.Button value="NT">Notification</Radio.Button>
            </Radio.Group>
          </Col>
        </Row>
      </div>
      {type == "PD" && (
        <div className="create_user">
          <Form
            layout="vertical"
            requiredMark={false}
            form={personalForm}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            validateTrigger="onSubmit"
          >
            <Row gutter={24}>
              <Col span={12}>
                <Form.Item
                  label="Name*"
                  name="name"
                  rules={[
                    {
                      required: true,
                      message: "Please enter name",
                    },
                  ]}
                >
                  <Input className="" placeholder="Name" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="Email*"
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: "Please enter email",
                    },
                    {
                      type: "email",
                      message: "Enter valid email",
                    },
                  ]}
                >
                  <Input
                    className=""
                    placeholder="Email"
                    type="email"
                    disabled={data?.isVerified}
                  />
                </Form.Item>
              </Col>
            </Row>
           
            <Row gutter={24}>
              <Col span={12}>
                <Form.Item
                  label="D.O.B*"
                  name="dob"
                  rules={[
                    {
                      required: true,
                      message: "Please enter D.O.B",
                    },
                  ]}
                >
                  <DatePicker
                    className="w-100"
                    format={"DD-MM-YYYY"}
                    //  value={data?.candidate?.candidate?.dob ? dayjs(data.candidate.candidate.dob) : null}
                    // defaultValue={dayjs(data?.candidate?.candidate?.dob, 'DD-MM-YYYY')}
                    placeholder="Select date of birth"
                    style={{ height: "38px" }}
                  />
                </Form.Item>
              </Col>
              <Col xs={12} className="inputCol">
                <label className="inputCol1">Contact Number*</label>
                <PhoneNumber />
              </Col>
            </Row>
            <Row gutter={24}>
              <Col xs={12} className="inputCol">
                <Form.Item
                  label="Gender*"
                  name="gender"
                  rules={[
                    {
                      required: true,
                      message: "Please enter gender",
                    },
                  ]}
                >
                  <Select className="" placeholder="Select gender">
                    <Select.Option value="male">Male</Select.Option>
                    <Select.Option value="female">Female</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="Ethnicity*"
                  name="ethnicity"
                  rules={[
                    {
                      required: true,
                      message: "Please select ethnicity",
                    },
                  ]}
                >
                  <Select className="" placeholder="Ethnicity">
                    {ethnicity.map((e, key) => {
                      return (
                        <Select.Option key={key} value={e.id}>
                          {e.name}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={12}>
                <Form.Item
                  label="Discipline*"
                  name="discipline"
                  rules={[
                    {
                      required: true,
                      message: "Please select discipline",
                    },
                  ]}
                >
                  <Select className="" placeholder="discipline">
                    {discipline.map((e, key) => {
                      return (
                        <Select.Option key={key} value={e.id}>
                          {e.name}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12} style={{ marginTop: "30px" }}>
                <Form.Item
                  label="Availability Status*"
                  name="isAvailable"
                  rules={[
                    {
                      required: true,
                      message: "Please select availability",
                    },
                  ]}
                >
                  <Radio.Group>
                    <Radio value={true}>Available for work</Radio>
                    <Radio value={false}>Not available for work</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
            </Row>
            <Form.Item shouldUpdate={(prevValues, currentValues) => prevValues.nextOfKinRelation !== currentValues.nextOfKinRelation}>
              {({ getFieldValue }) => (
                <Row gutter={24}>
                  <Col span={8}>
                    <Form.Item
                      label="Next of kin"
                      name="nextOfKinName"
                      rules={[
                        ({ getFieldValue }) => ({
                          required: !!getFieldValue('nextOfKinRelation'),
                          message: "Please enter next of kin name",
                        }),
                      ]}
                    >
                      <Input 
                        className="" 
                        placeholder="Next of kin" 
                        disabled={!getFieldValue('nextOfKinRelation')}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item
                      label="Next of kin contact details"
                      name="nextOfKinEmail"
                      rules={[
                        ({ getFieldValue }) => ({
                          required: !!getFieldValue('nextOfKinRelation'),
                          message: "Please enter next of kin contact details",
                        }),
                      ]}
                    >
                      <Input 
                        className="" 
                        placeholder="Next of kin email" 
                        type="text" 
                        disabled={!getFieldValue('nextOfKinRelation')}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item
                      label="Start / Notice*"
                      name="availabilityDetails"
                      rules={[
                        {
                          required: true,
                          message: "Please select availability",
                        },
                      ]}
                    >
                      <Select className="" placeholder="availability">
                        {availability.map((e, key) => {
                          return (
                            <Select.Option key={key} value={e.id}>
                              {e.name}
                            </Select.Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
              )}
            </Form.Item>
            <Row gutter={24}>
              <Col span={8}>
                <Form.Item
                  label="Next of kin Relation"
                  name="nextOfKinRelation"
                  rules={[
                    {
                      required: false,
                      message: "Please select next of kin relation",
                    },
                  ]}
                >
                  <Select 
                    className="" 
                    placeholder="Select relation"
                    showSearch
                    optionFilterProp="children"
                    allowClear
                    onChange={(value) => {
                      if (!value) {
                        personalForm.setFieldsValue({
                          nextOfKinName: undefined,
                          nextOfKinEmail: undefined,
                        });
                      }
                      personalForm.validateFields(['nextOfKinName', 'nextOfKinEmail']);
                    }}
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {nextOfKinRelation.map((e, key) => {
                      return (
                        <Select.Option key={key} value={e.id}>
                          {e.name}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={6} className="buttonCol">
              <Col>
                <Button
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  Cancel
                </Button>
              </Col>
              <Col>
                <Button
                  className="btn"
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                >
                  Save
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      )}
      {type == "LT" && (
        <div className="create_user">
          <Form
            layout="vertical"
            requiredMark={false}
            form={locationForm}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            validateTrigger="onSubmit"
          >
            <Row gutter={24}>
              <Col span={12}>
                <Form.Item
                  label="Choose Location"
                  name="location"
                >
                  <Input className="" placeholder="location" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="Street Name and No.*"
                  name="street"
                  rules={[
                    {
                      required: true,
                      message: "Please enter street",
                    },
                  ]}
                >
                  <Input className="" placeholder="Street" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={12}>
                <Form.Item
                  label="City/Suburb*"
                  name="city"
                  rules={[
                    {
                      required: true,
                      message: "Please enter city",
                    },
                  ]}
                >
                  <Input className="" placeholder="City" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="State*"
                  name="state"
                  rules={[
                    {
                      required: true,
                      message: "Please enter state",
                    },
                  ]}
                >
                  <Input className="" placeholder="State" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={12}>
                <Form.Item
                  label="Postal Code*"
                  name="postalCode"
                  rules={[
                    {
                      required: true,
                      message: "Please enter postalCode",
                    },
                  ]}
                >
                  <Input className="" placeholder="Postal Code" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="Country*"
                  name="country"
                  rules={[
                    {
                      required: true,
                      message: "Please enter country",
                    },
                  ]}
                >
                  <Input className="" placeholder="Country" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={6} className="buttonCol">
              <Col>
                <Button
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  Cancel
                </Button>
              </Col>
              <Col>
                <Button
                  className="btn"
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                >
                  Save
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      )}
      {type == "PE" && (
        <>
          <Row>
            <Col
              xs={24}
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Button
                className="bulk_button"
                onClick={() => {
                  setAddExperience(true);
                }}
              >
                Add Experience
              </Button>
            </Col>
          </Row>
          <div
            style={{ marginTop: "20px" }}
            className="professional_experience_container"
          >
            <div className="professional_summary_box">
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <img
                  src={EditCandidateIcon}
                  onClick={() => setResumeEdit(true)}
                />
              </div>
              <div>
                {data?.candidate?.introVideo && (
                  <>
                    {/* <p className="title">Intro Video</p> */}
                    {/* Thumbnail card */}
                    <Col
                      xs={24}
                      md={12}
                      style={{
                        width: "280px",
                        borderRadius: "16px",
                        overflow: "hidden",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                        background: "#f8f9ff",
                        padding: "0px",
                        marginBottom: "30px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        position: "relative",
                        height: "120px",
                      }}
                      onClick={handleOpen}
                    >
                      <img
                        src={Thumbnail}
                        alt="Intro Video"
                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                      />
                      {/* Play button overlay */}
                      <div
                        style={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          width: "50px",
                          height: "50px",
                          borderRadius: "50%",
                          background: "rgba(0,0,0,0.6)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <div
                          style={{
                            width: 0,
                            height: 0,
                            borderLeft: "16px solid #fff",
                            borderTop: "10px solid transparent",
                            borderBottom: "10px solid transparent",
                          }}
                        />
                      </div>
                    </Col>

                    {/* Modal with video */}
                    <Modal
                      title="Intro Video"
                      open={isModalOpen}
                      onCancel={handleClose}
                      footer={null}
                      centered
                      width={720}
                      bodyStyle={{ padding: 0 }}
                      destroyOnClose={true}
                      zIndex={9999}
                    >
                      <video
                        src={data?.candidate?.introVideo}
                        autoPlay={true}
                        controls
                        width="100%"
                        height="400px"
                      />
                    </Modal>
                  </>
                )}
                
                <p className="title" style={{marginTop:"15px"}}>Profile Summary Description</p>
                <p className="desc">
                  {data?.candidate?.profileSummary}
                </p>
              </div>
              {data?.candidate?.resume?.length > 0 && (
                <div className="mt-30">
                  <p className="title">Resume</p>
                  <Row>
                    <Col span={18}>
                      <DocumentBox
                        date={data?.candidate?.resume[0]?.createdAt}
                        url={data?.candidate?.resume[0]?.resume}
                      />
                    </Col>
                  </Row>
                </div>
              )}
            </div>
            <div>
              <Row gutter={18}>
                {profExp?.map((item, index) => {
                  const uniqueKey = item._id || item.id || `exp-${index}`;
                  return (
                    <Col md={24} key={uniqueKey}>
                      <JobPositionCard
                        data={item}
                        discipline={discipline}
                        induction={induction}
                        industry={industry}
                        skills={skills}
                        profileId={data?.candidate?._id}
                        jobTitle={jobTitle}
                        expEdit={expEdit}
                        setExpEdit={setExpEdit}
                        onUpdate={getData}
                        userId={data?.candidate?.userId}
                      />
                    </Col>
                  );
                })}
              </Row>
            </div>
          </div>
        </>
      )}
      {type == "QT" && (
        <>
          <Row>
            <Col
              xs={24}
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Button
                className="bulk_button"
                onClick={() => {
                  setAddQualification(true);
                }}
              >
                Add Qualification
              </Button>
            </Col>
          </Row>
          {data?.candidate?.qualifications?.length > 0 && (
            <div className="create_user">
              <div className="qualification_container">
                {data?.candidate?.qualifications.map((e, key) => {
                  return (
                    <div style={{ marginBottom: "20px" }} key={key}>
                      <div className="qualification_summary_box mb-16">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: "10px",
                          }}
                        >
                          <img
                            src={DeleteIcon}
                            alt="delete"
                            style={{ 
                              width: "35px", 
                              height: "35px",
                              cursor: "pointer",
                              filter: "none",
                              background: "transparent",
                              border: "none",
                              padding: 0
                            }}
                            onClick={() => {
                              setDeleteType("qualification");
                              setDeleteItemId(e._id || e.id);
                              setDeleteCandidateId(data?.candidate?._id);
                              setDeleteModalVisible(true);
                            }}
                          />
                          <img
                            src={EditCandidateIcon}
                            onClick={() => {
                              setQualificationEdit(true),
                                setQualificationData(e);
                            }}
                          />
                        </div>
                        <Row
                          gutter={8}
                          className="align_center"
                          align={"middle"}
                          style={{ marginBottom: "10px" }}
                        >
                          <Col className="align_center">
                            <p className="title mb-0">
                              {e.qualificationType.name}{" "}
                            </p>
                          </Col>
                          {e?.isValidate && (
                            <Col>
                              <svg
                                style={{ marginBottom: "16px !important" }}
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M8 1C4.13438 1 1 4.13438 1 8C1 11.8656 4.13438 15 8 15C11.8656 15 15 11.8656 15 8C15 4.13438 11.8656 1 8 1ZM11.0234 5.71406L7.73281 10.2766C7.68682 10.3408 7.62619 10.3931 7.55595 10.4291C7.48571 10.4652 7.40787 10.4841 7.32891 10.4841C7.24994 10.4841 7.17211 10.4652 7.10186 10.4291C7.03162 10.3931 6.97099 10.3408 6.925 10.2766L4.97656 7.57656C4.91719 7.49375 4.97656 7.37813 5.07812 7.37813H5.81094C5.97031 7.37813 6.12187 7.45469 6.21562 7.58594L7.32812 9.12969L9.78438 5.72344C9.87813 5.59375 10.0281 5.51562 10.1891 5.51562H10.9219C11.0234 5.51562 11.0828 5.63125 11.0234 5.71406Z"
                                  fill="#31B948"
                                />
                              </svg>
                            </Col>
                          )}
                        

                          <Col>
                            <span>
                              <Button
                                onClick={() =>
                                  handleVerified(e, "qualification")
                                }
                                disabled={e?.isValidate}
                              >
                                {!e?.isValidate ? "Verify" : "Verified"}
                              </Button>
                            </span>
                          </Col>
                          <Col>
                            <span>
                              <img
                                style={{ width: "25px" }}
                                className="cursor-pointer"
                                src={TelegramIcon}
                                alt="send mail"
                                onClick={() => {
                                  setTicketType("qualification");
                                  setTicketId(e?._id || e?.id);
                                  setNotify(true);
                                }}
                              />
                            </span>
                          </Col>
                        </Row>
                        <Row gutter={[16, 16]} align="top">
                          <Col
                            span={e?.uploadedDocumentBack && e?.uploadedDocumentBack !== "" ? 7 : 14}
                            onClick={() => {
                              if (e?.uploadedDocument) {
                                window.open(e?.uploadedDocument);
                              }
                            }}
                            style={{ cursor: 'pointer' }}
                          >
                            <DocumentBox
                              date={e?.issueDate}
                              url={e?.uploadedDocument}
                            />
                          </Col>
                          {e?.uploadedDocumentBack && e?.uploadedDocumentBack !== "" && (
                            <Col
                              span={7}
                              onClick={() => {
                                if (e?.uploadedDocumentBack) {
                                  window.open(e?.uploadedDocumentBack);
                                }
                              }}
                              style={{ cursor: 'pointer' }}
                            >
                              <DocumentBox
                                date={e?.issueDate}
                                url={e?.uploadedDocumentBack}
                              />
                            </Col>
                          )}
                          <Col 
                            span={e?.uploadedDocumentBack && e?.uploadedDocumentBack !== "" ? 10 : 10}
                            style={{ paddingLeft: '16px' }}
                          >
                            <Row gutter={[0, 8]}>
                              <Col span={24}>
                                <p className="item" style={{ marginBottom: '4px', fontSize: '12px', color: '#666' }}>Issue Date</p>
                                <p className="value" style={{ marginBottom: '0', fontWeight: '600', fontSize: '14px' }}>
                                  {e?.issueDate
                                    ? moment(e?.issueDate).format("DD MMM YYYY")
                                    : "----"}
                                </p>
                              </Col>
                              <Col span={24}>
                                <p className="item" style={{ marginBottom: '4px', fontSize: '12px', color: '#666' }}>Expiry Date</p>
                                <p className="value" style={{ marginBottom: '0', fontWeight: '600', fontSize: '14px' }}>
                                  {e?.expiryDate
                                    ? moment(e?.expiryDate).format("DD MMM YYYY")
                                    : "----"}
                                </p>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                        <div className="mt-30">
                          <Row gutter={24}>
                            <Col span={7}>
                              <p className="item">Member No./ID</p>
                              <p className="value">
                                {e?.memberId ? e?.memberId : "----"}
                              </p>
                            </Col>
                            <Col span={7}>
                              <p className="item">State/Country</p>
                              <p className="value">
                                {e?.stateOrCountry ? e?.stateOrCountry : "----"}
                              </p>
                            </Col>
                            <Col span={10}>
                              <p className="item">
                                Licence Type/Class/Category
                              </p>
                              <p className="value">
                                {Array.isArray(e?.licenceType) && e?.licenceType?.length > 0
                                  ? e?.licenceType?.map((item, index) => (
                                      <p
                                        key={index}
                                        className="w-100"
                                        style={{ margin: "0", padding: "0" }}
                                      >
                                        {index === e?.licenceType?.length - 1
                                          ? item?.name
                                          : ` ${item?.name}, `}
                                      </p>
                                    ))
                                  : "----"}
                              </p>
                            </Col>
                            <Col xs={24}>
                              {(e?.hasSOA || e?.SOADocument) || (e?.hasVOC || e?.VOCDocument) ? (
                                <div className="qualification_detail_box">
                                  {(e?.hasSOA || e?.SOADocument) && (
                                    <div className="collapseContainer">
                                      <Collapse
                                        // size="small"
                                        expandIconPosition={"end"}
                                        bordered={false}
                                        items={[
                                          {
                                            key: "1",
                                            label: "Statement of Attainment",
                                            children: (
                                              <Row gutter={24}>
                                                <Col
                                                  span={14}
                                                  onClick={() => {
                                                    if (e?.SOADocument) {
                                                      window.open(
                                                        e?.SOADocument
                                                      );
                                                    }
                                                  }}
                                                >
                                                  <DocumentBox
                                                    date={e?.SOAIssueDate}
                                                    url={e?.SOADocument}
                                                  />
                                                </Col>
                                                <Col span={110}>
                                                  <p className="item">
                                                    Issue Date
                                                  </p>
                                                  <p className="value">
                                                    {e?.SOAIssueDate
                                                      ? moment(
                                                          e?.SOAIssueDate
                                                        ).format("DD MMM YYYY")
                                                      : "----"}
                                                  </p>
                                                </Col>
                                              </Row>
                                            ),
                                          },
                                        ]}
                                      />
                                    </div>
                                  )}

                                  {(e?.hasVOC || e?.VOCDocument) && (
                                    <>
                                      <Divider className="horizontalDivider" />
                                      <div className="collapseContainer">
                                        <Collapse
                                          // size="small"
                                          expandIconPosition={"end"}
                                          bordered={false}
                                          items={[
                                            {
                                              key: "1",
                                              label:
                                                "Verification of Competency",
                                              children: (
                                                <Row gutter={24}>
                                                  <Col
                                                    span={14}
                                                    onClick={() => {
                                                      if (e?.VOCDocument) {
                                                        window.open(
                                                          e?.VOCDocument
                                                        );
                                                      }
                                                    }}
                                                  >
                                                    <DocumentBox
                                                      date={e?.VOCIssueDate}
                                                      url={e?.VOCDocument}
                                                    />
                                                  </Col>
                                                  <Col span={10}>
                                                    <Row
                                                      justify={"space-between"}
                                                    >
                                                      <Col span={12}>
                                                        <p className="item">
                                                          {" "}
                                                          Verification Type
                                                        </p>
                                                        <p className="value">
                                                          {e?.VOCType?.name
                                                            ? e?.VOCType?.name
                                                            : "----"}
                                                        </p>
                                                      </Col>
                                                      <Col span={12}>
                                                        <p className="item">
                                                          Issue Date{" "}
                                                        </p>
                                                        <p className="value">
                                                          {e?.VOCIssueDate
                                                            ? moment(
                                                                e?.VOCIssueDate
                                                              ).format(
                                                                "DD MMM YYYY"
                                                              )
                                                            : "----"}
                                                        </p>
                                                      </Col>
                                                    </Row>
                                                  </Col>
                                                </Row>
                                              ),
                                            },
                                          ]}
                                        />
                                      </div>
                                    </>
                                  )}
                                </div>
                              ) : (
                                ""
                              )}
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </>
      )}
      {type == "OD" && (
        <div style={{ marginTop: "20px" }} className="other_detail_container">
          <Row>
            <Col
              xs={24}
              style={{
                display: "flex",
                justifyContent: "flex-end",
                margin: "-20px 0px 10px 0px",
              }}
            >
              <Button
                className="bulk_button"
                onClick={() => {
                  setAddDocument(true);
                }}
              >
                Add Document
              </Button>
            </Col>
          </Row>
          <div className="citizen_container">
            {/* Citizenship Status - Show only when VISA documents are present */}
            {data?.candidate?.documents?.some(doc => doc?.documentType?.name === "VISA") && (
              <div style={{ 
                marginBottom: "20px", 
                padding: "12px 16px", 
                background: "#f5f5f5", 
                borderRadius: "8px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center"
              }}>
                <div>
                  <span style={{ fontSize: "14px", color: "#666", marginRight: "8px" }}>
                    Citizenship Status:
                  </span>
                  <span style={{ fontSize: "16px", fontWeight: "600", color: "#000" }}>
                    {citizen === "australian" ? "Australian" : "Non-Australian"}
                  </span>
                </div>
                <EditFilled 
                  onClick={() => {
                    setSelectedCitizenship(citizen);
                    setCitizenshipEditModalVisible(true);
                  }}
                  style={{ 
                    fontSize: "18px", 
                    cursor: "pointer",
                    color: "#1890ff"
                  }}
                />
              </div>
            )}
            {data?.candidate?.documents?.map((e, key) => {
              return (
                <div key={key} style={{ marginBottom: "20px" }}>
                  <div className="titleBox">
                    <div
                      style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
                    >
                      <img
                        src={DeleteIcon}
                        alt="delete"
                        style={{ 
                          width: "35px", 
                          height: "35px",
                          cursor: "pointer",
                          filter: "none",
                          background: "transparent",
                          border: "none",
                          padding: 0
                        }}
                        onClick={() => {
                          setDeleteType("document");
                          setDeleteItemId(e._id || e.id);
                          setDeleteUserId(data?.candidate?.userId);
                          setDeleteIsVisa(e?.documentType?.name === "VISA");
                          setDeleteModalVisible(true);
                        }}
                      />
                      <img
                        src={EditCandidateIcon}
                        onClick={() => {
                          setOtherDetailEdit(true), setOtherDocumentData(e);
                        }}
                      />
                    </div>
                    <Row
                      gutter={8}
                      className="align_center"
                      align={"middle"}
                      style={{ marginBottom: "10px" }}
                    >
                      <Col className="align_center">
                        <p className="title mb-0">
                          {e.documentType.name}
                        </p>
                      </Col>
                      {e?.isVerfied && (
                        <Col>
                          <svg
                            style={{ marginBottom: "16px !important" }}
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8 1C4.13438 1 1 4.13438 1 8C1 11.8656 4.13438 15 8 15C11.8656 15 15 11.8656 15 8C15 4.13438 11.8656 1 8 1ZM11.0234 5.71406L7.73281 10.2766C7.68682 10.3408 7.62619 10.3931 7.55595 10.4291C7.48571 10.4652 7.40787 10.4841 7.32891 10.4841C7.24994 10.4841 7.17211 10.4652 7.10186 10.4291C7.03162 10.3931 6.97099 10.3408 6.925 10.2766L4.97656 7.57656C4.91719 7.49375 4.97656 7.37813 5.07812 7.37813H5.81094C5.97031 7.37813 6.12187 7.45469 6.21562 7.58594L7.32812 9.12969L9.78438 5.72344C9.87813 5.59375 10.0281 5.51562 10.1891 5.51562H10.9219C11.0234 5.51562 11.0828 5.63125 11.0234 5.71406Z"
                              fill="#31B948"
                            />
                          </svg>
                        </Col>
                      )}
                      <Col>
                        <span>
                          <Button
                            onClick={() => handleVerified(e, "other")}
                            disabled={e?.isVerfied}
                          >
                            {!e?.isVerfied ? "Verify" : "Verified"}
                          </Button>
                        </span>
                      </Col>
                      <Col>
                        <span>
                          <img
                            style={{ width: "25px" }}
                            className="cursor-pointer"
                            src={TelegramIcon}
                            alt="send mail"
                            onClick={() => {
                              setTicketType("otherDetails");
                              setTicketId(e?._id || e?.id);
                              setNotify(true);
                            }}
                          />
                        </span>
                      </Col>
                    </Row>
                  </div>
                  <div className="detail-container">
                    <Row gutter={[16, 16]} align="top">
                      <Col
                        span={(e?.documentType?.name === "VISA" || e?.documentType?.name === "Driver Licence" || e?.documentType?.name === "Proof of Age/Photo Card") && e?.documentBack && e?.documentBack !== "" ? 7 : 14}
                        onClick={() => {
                          if (e?.document) {
                            window.open(e?.document);
                          }
                        }}
                        style={{ cursor: 'pointer' }}
                      >
                        <DocumentBox date={e.createdAt} url={e.document} />
                      </Col>
                      {(e?.documentType?.name === "VISA" || e?.documentType?.name === "Driver Licence" || e?.documentType?.name === "Proof of Age/Photo Card") && e?.documentBack && e?.documentBack !== "" && (
                        <Col
                          span={7}
                          onClick={() => {
                            if (e?.documentBack) {
                              window.open(e?.documentBack);
                            }
                          }}
                          style={{ cursor: 'pointer' }}
                        >
                          <DocumentBox
                            date={e.createdAt}
                            url={e.documentBack}
                          />
                        </Col>
                      )}
                      <Col 
                        span={(e?.documentType?.name === "VISA" || e?.documentType?.name === "Driver Licence" || e?.documentType?.name === "Proof of Age/Photo Card") && e?.documentBack && e?.documentBack !== "" ? 10 : 10}
                        style={{ paddingLeft: '16px' }}
                      >
                        <Row justify={"space-between"}>
                          <Col span={12}>
                            {e.documentType.name === "VISA" && (
                              <>
                                <p className="item">Grant No</p>
                                <p className="value">
                                  {e?.documentData?.grantNo || "----"}
                                </p>
                              </>
                            )}
                            {e.documentType.name === "Passport" && (
                              <>
                                <p className="item">Nationality</p>
                                <p className="value">
                                  {renderPickValue(e?.documentData?.nationality)}
                                </p>
                              </>
                            )}
                            {e.documentType.name === "Driver Licence" && (
                              <>
                                <p className="item">State</p>
                                <p className="value">
                                  {renderPickValue(e?.documentData?.stateDL || e?.documentData?.state)}
                                </p>
                              </>
                            )}
                            {e.documentType.name ===
                              "Proof of Age/Photo Card" && (
                              <>
                                <p className="item">State</p>
                                <p className="value">{renderPickValue(e?.documentData?.state)}</p>
                              </>
                            )}
                            {e.documentType.name ===
                              "Driver Licence" && (
                              <Row
                                style={{ marginTop: "10px" }}
                                justify={"space-between"}
                                gutter={24}
                              >
                                <Col span={12}>
                                  <p className="item">{"Class"}</p>
                                  <p className="value">
                                    {Array.isArray(e?.documentData?.class) && e?.documentData?.class?.length > 0
                                      ? e?.documentData?.class?.map(
                                          (item) => {
                                            return `${item} `;
                                          }
                                        )
                                      : "-"}
                                  </p>
                                </Col>
                                <Col span={12}>
                                  <p className="item">{"Conditions"}</p>
                                  <p className="value">
                                    {Array.isArray(e?.documentData?.conditions) && e?.documentData?.conditions?.length > 0
                                      ? e?.documentData?.conditions?.map(
                                          (item) => {
                                            return `${item} `;
                                          }
                                        )
                                      : "-"}
                                  </p>
                                </Col>
                              </Row>
                            )}
                            {e.documentType.name !== "VISA" && (
                              <div className="mt-16">
                                <p className="item">Expiry Date</p>
                                <p className="value">
                                  {e?.documentData?.expiryDate
                                    ? (() => {
                                        const formattedDate = moment(e?.documentData?.expiryDate).format("DD-MMM-YYYY");
                                        const epochDate = moment("1970-01-01").format("DD-MMM-YYYY");
                                        return formattedDate === epochDate ? "----" : formattedDate;
                                      })()
                                    : "----"}
                                </p>
                              </div>
                            )}
                          </Col>
                          <Col span={12}>
                            <p className="item">
                              {e.documentType.name === "Passport"
                                ? "Passport Number"
                                : e.documentType.name === "Driver Licence"
                                ? "Licence Number"
                                : e.documentType.name === "VISA"
                                ? "Visa Type No"
                                : "Id Number"}
                            </p>
                            <p className="value">
                              {e.documentType.name === "Passport"
                                ? e?.documentData?.passportNumber
                                : e?.documentType?.name === "Driver Licence"
                                ? getLicenceNo(e)
                                : e.documentType.name === "VISA"
                                ? (e?.documentData?.visaTypeNo?.name || renderPickValue(e?.documentData?.visaTypeNo))
                                : e?.documentData?.idNumber}
                            </p>
                          </Col>
                        </Row>
                        {e.documentType.name === "VISA" && (
                          <Row justify={"space-between"} style={{ marginTop: "16px" }}>
                            <Col span={12}>
                              <p className="item">Expiry Date</p>
                              <p className="value">
                                {e?.documentData?.expiryDate
                                  ? (() => {
                                      const formattedDate = moment(e?.documentData?.expiryDate).format("DD-MMM-YYYY");
                                      const epochDate = moment("1970-01-01").format("DD-MMM-YYYY");
                                      return formattedDate === epochDate ? "----" : formattedDate;
                                    })()
                                  : "----"}
                              </p>
                            </Col>
                            <Col span={12}>
                              <p className="item">Issue Date</p>
                              <p className="value">
                                {e?.documentData?.issueDate
                                  ? moment(e?.documentData?.issueDate).format("DD-MMM-YYYY")
                                  : "----"}
                              </p>
                            </Col>
                          </Row>
                        )}
                      </Col>
                    </Row>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="additional_detail_container">
            <div className="titleBox">
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <img
                  src={EditCandidateIcon}
                  onClick={() => {
                    setAdditionalEdit(true);
                  }}
                />
              </div>
              Additional Personal Details
            </div>
            <div className="detail-container">
              <Row gutter={16}>
                <Col span={8}>
                  <p className="item">Tax File Number (TFN)</p>
                  <p className="value">
                    {data?.candidate?.otherDetails[0]?.tfnNo
                      ? data?.candidate?.otherDetails[0]?.tfnNo
                      : "----"}
                  </p>
                </Col>
                <Col span={8}>
                  <p className="item">USI No.</p>
                  <p className="value">
                    {data?.candidate?.otherDetails[0]?.usiNo
                      ? data?.candidate?.otherDetails[0]?.usiNo
                      : "----"}
                  </p>
                </Col>
              </Row>
              {data?.candidate?.otherDetails[0]?.isSuperannuation && (
                <>
                  <Divider className="horizontalDivider" />
                  <div>
                    <p className="title">Superannuation</p>
                    <Row gutter={16}>
                      <Col span={8}>
                        <p className="item">Fund Name</p>
                        <p className="value">
                          {
                            data?.candidate?.otherDetails[0]
                              ?.superannuationDetails?.fundName?.name
                          }
                        </p>
                      </Col>
                      <Col span={8}>
                        <p className="item">Fund USI/ABN</p>
                        <p className="value">
                          {
                            data?.candidate?.otherDetails[0]
                              ?.superannuationDetails?.fundName
                              ?.correspondingValue
                          }
                        </p>
                      </Col>
                      <Col span={8}>
                        <p className="item">Member Number</p>
                        <p className="value">
                          {
                            data?.candidate?.otherDetails[0]
                              ?.superannuationDetails?.memberNumber
                          }
                        </p>
                      </Col>
                    </Row>
                  </div>
                </>
              )}
              {data?.candidate?.otherDetails[0]?.isLSL && (
                <>
                  <Divider className="horizontalDivider" />
                  <div>
                    <p className="title">Long Service Leaves</p>
                    <Row gutter={16}>
                      {Array.isArray(data?.candidate?.otherDetails[0]?.lslDetails) && data?.candidate?.otherDetails[0]?.lslDetails?.map(
                        (item, index) => {
                          return (
                            <>
                              <Col
                                span={8}
                                style={{
                                  marginTop: index !== 0 ? "12px" : "0px",
                                }}
                              >
                                <p className="item">State</p>
                                <p className="value"> {item?.state?.name}</p>
                              </Col>

                              <Col
                                span={16}
                                style={{
                                  marginTop: index !== 0 ? "12px" : "0px",
                                }}
                              >
                                <p className="item">Member Number</p>
                                <p className="value">{item?.memberNumber}</p>
                              </Col>
                            </>
                          );
                        }
                      )}
                    </Row>
                  </div>
                </>
              )}

              {data?.candidate?.otherDetails[0]?.isPPE && (
                <>
                  <Divider className="horizontalDivider" />
                  <div>
                    <p className="title">PPE Details</p>
                    {console.log(
                      "data?.candidate?.otherDetails[0]?.ppeDetails",
                      data?.candidate?.otherDetails[0]?.ppeDetails
                    )}
                    <Row gutter={16}>
                      <Col span={8}>
                        <p className="item">Top</p>
                        <p className="value">
                          {
                            data?.candidate?.otherDetails[0]?.ppeDetails?.shirt
                              ?.name
                          }
                        </p>
                      </Col>

                      <Col span={8}>
                        <p className="item">Bottom</p>
                        <p className="value">
                          {
                            data?.candidate?.otherDetails[0]?.ppeDetails?.pants
                              ?.name
                          }
                        </p>
                      </Col>
                      <Col span={8}>
                        <p className="item">Boots</p>
                        <p className="value">
                          {
                            data?.candidate?.otherDetails[0]?.ppeDetails?.boots
                              ?.name
                          }
                        </p>
                      </Col>
                    </Row>
                  </div>
                </>
              )}
              {data?.candidate?.otherDetails[0]?.hasTravelDetails && (
                <>
                  <Divider className="horizontalDivider" />
                  <div>
                    <p className="title">Travel Details</p>
                    <Row gutter={16}>
                      <Col span={8}>
                        <p className="item">Preferred Airline</p>
                        <p className="value">
                          {renderPickValue(
                            data?.candidate?.otherDetails[0]?.travelDetails
                              ?.preferredAirline
                          )}
                        </p>
                      </Col>

                      <Col span={8}>
                        <p className="item">Frequent Flyer Number</p>
                        <p className="value">
                          {
                            data?.candidate?.otherDetails[0]?.travelDetails
                              ?.frequentFlyerNumber
                          }
                        </p>
                      </Col>
                    </Row>
                  </div>
                </>
              )}
            </div>
          </div>

          {!((data?.candidate?.otherDetails && data?.candidate?.otherDetails.length > 0 && data?.candidate?.otherDetails[0]?.hasPoliceClearance) || 
             (data?.candidate?.otherDetails && data?.candidate?.otherDetails.length > 0 && data?.candidate?.otherDetails[0]?.policeClearanceDetails)) && (
            <div style={{ marginTop: "20px", marginBottom: "20px" }}>
              <Button
                className="bulk_button"
                onClick={() => {
                  setPoliceClearanceEdit(true);
                  setPoliceClearanceData({
                    userId: data?.candidate?.userId,
                  });
                }}
              >
                Add Police Clearance
              </Button>
            </div>
          )}
          {((data?.candidate?.otherDetails && data?.candidate?.otherDetails.length > 0 && data?.candidate?.otherDetails[0]?.hasPoliceClearance) || 
            (data?.candidate?.otherDetails && data?.candidate?.otherDetails.length > 0 && data?.candidate?.otherDetails[0]?.policeClearanceDetails)) && (
            <div className="clearance_box">
              <div className="titleBox" style={{marginTop:"20px"}}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <span>Police Clearance</span>
                    {data?.candidate?.otherDetails[0]?.policeClearanceDetails?.isVerified && (
                      <svg
                        style={{ marginBottom: "16px !important" }}
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8 1C4.13438 1 1 4.13438 1 8C1 11.8656 4.13438 15 8 15C11.8656 15 15 11.8656 15 8C15 4.13438 11.8656 1 8 1ZM11.0234 5.71406L7.73281 10.2766C7.68682 10.3408 7.62619 10.3931 7.55595 10.4291C7.48571 10.4652 7.40787 10.4841 7.32891 10.4841C7.24994 10.4841 7.17211 10.4652 7.10186 10.4291C7.03162 10.3931 6.97099 10.3408 6.925 10.2766L4.97656 7.57656C4.91719 7.49375 4.97656 7.37813 5.07812 7.37813H5.81094C5.97031 7.37813 6.12187 7.45469 6.21562 7.58594L7.32812 9.12969L9.78438 5.72344C9.87813 5.59375 10.0281 5.51562 10.1891 5.51562H10.9219C11.0234 5.51562 11.0828 5.63125 11.0234 5.71406Z"
                          fill="#31B948"
                        />
                      </svg>
                    )}
                    <Button
                      onClick={() =>
                        handleVerified(
                          {
                            id: data?.candidate?.otherDetails[0]?.id,
                          },
                          "police_clearence"
                        )
                      }
                      disabled={
                        data?.candidate?.otherDetails[0]
                          ?.policeClearanceDetails?.isVerified
                      }
                    >
                      {!data?.candidate?.otherDetails[0]
                        ?.policeClearanceDetails?.isVerified
                        ? "Verify"
                        : "Verified"}
                    </Button>
                    <img
                      style={{ width: "25px" }}
                      className="cursor-pointer"
                      src={TelegramIcon}
                      alt="send mail"
                      onClick={() => {
                        setTicketType("otherDetails");
                        setTicketId(data?.candidate?.otherDetails[0]?.id);
                        setNotify(true);
                      }}
                    />
                  </div>
                  <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                    <img
                      src={DeleteIcon}
                      alt="delete"
                      style={{ 
                        width: "35px", 
                        height: "35px",
                        cursor: "pointer",
                        filter: "none",
                        background: "transparent",
                        border: "none",
                        padding: 0
                      }}
                      onClick={() => {
                        setDeleteType("policeClearance");
                        setDeleteUserId(data?.candidate?.userId);
                        setDeleteModalVisible(true);
                      }}
                    />
                    <img
                      src={EditCandidateIcon}
                      onClick={() => {
                        setPoliceClearanceEdit(true);
                        setPoliceClearanceData({
                          ...data?.candidate?.otherDetails[0],
                          userId: data?.candidate?.userId,
                        });
                      }}
                      style={{ cursor: "pointer" }}
                      alt="Edit"
                    />
                  </div>
                </div>
              </div>
              <div className="detail-container">
                <Row gutter={24}>
                  <Col span={14}>
                    <DocumentBox
                      date={
                        data?.candidate?.otherDetails[0]?.policeClearanceDetails
                          ?.issueDate
                      }
                      url={
                        data?.candidate?.otherDetails[0]?.policeClearanceDetails
                          ?.document
                      }
                    />
                  </Col>
                  <Col span={10}>
                    <Row justify={"space-between"} gutter={12}>
                      <Col span={12}>
                        <p className="item">Certifying Authority</p>
                        <p className="value">
                          {
                            data?.candidate?.otherDetails[0]
                              ?.policeClearanceDetails?.certifyingAuthority?.name
                          }
                        </p>
                      </Col>
                      <Col span={12}>
                        <p className="item">Issue Date </p>
                        <p className="value">
                          {moment(
                            data?.candidate?.otherDetails[0]
                              ?.policeClearanceDetails?.issueDate
                          ).format("DD MMM YYYY")}
                        </p>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            </div>
          )}
          {data?.candidate?.medicalAssessment[0]?.hasMedicalAssessment &&
            Array.isArray(data?.candidate?.medicalAssessment[0]?.medicals) &&
            data?.candidate?.medicalAssessment[0]?.medicals?.map((e, key) => {
              return (
                <div key={key}>
                  <div className="titleBox" style={{marginTop:"20px"}}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <span>Medical Assessment</span>
                        {e?.isValidate && (
                          <svg
                            style={{ marginBottom: "16px !important" }}
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8 1C4.13438 1 1 4.13438 1 8C1 11.8656 4.13438 15 8 15C11.8656 15 15 11.8656 15 8C15 4.13438 11.8656 1 8 1ZM11.0234 5.71406L7.73281 10.2766C7.68682 10.3408 7.62619 10.3931 7.55595 10.4291C7.48571 10.4652 7.40787 10.4841 7.32891 10.4841C7.24994 10.4841 7.17211 10.4652 7.10186 10.4291C7.03162 10.3931 6.97099 10.3408 6.925 10.2766L4.97656 7.57656C4.91719 7.49375 4.97656 7.37813 5.07812 7.37813H5.81094C5.97031 7.37813 6.12187 7.45469 6.21562 7.58594L7.32812 9.12969L9.78438 5.72344C9.87813 5.59375 10.0281 5.51562 10.1891 5.51562H10.9219C11.0234 5.51562 11.0828 5.63125 11.0234 5.71406Z"
                              fill="#31B948"
                            />
                          </svg>
                        )}
                        <Button
                          onClick={() =>
                            handleVerified(
                              {
                                profileId:
                                  data?.candidate
                                    ?.medicalAssessment[0]
                                    ?.profileId,
                                id: e?._id,
                              },
                              "medical"
                            )
                          }
                          disabled={e?.isValidate}
                        >
                          {!e?.isValidate ? "Verify" : "Verified"}
                        </Button>
                        <img
                          style={{ width: "25px" }}
                          className="cursor-pointer"
                          src={TelegramIcon}
                          alt="send mail"
                          onClick={() => {
                            setTicketType("otherDetails");
                            setTicketId(e?._id || e?.id);
                            setNotify(true);
                          }}
                        />
                      </div>
                      <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                        <img
                          src={DeleteIcon}
                          alt="delete"
                          style={{ 
                            width: "35px", 
                            height: "35px",
                            cursor: "pointer",
                            filter: "none",
                            background: "transparent",
                            border: "none",
                            padding: 0
                          }}
                          onClick={() => {
                            setDeleteType("medical");
                            setDeleteItemId(e._id || e.id);
                            setDeleteUserId(data?.candidate?.userId);
                            setDeleteModalVisible(true);
                          }}
                        />
                        <img
                          src={EditCandidateIcon}
                          onClick={() => {
                            setMedicalAssessmentEdit(true);
                            setMedicalAssessmentData({
                              ...e,
                              userId: data?.candidate?.userId
                            });
                          }}
                          style={{ cursor: "pointer" }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="detail-container">
                    <Row gutter={24}>
                      <Col span={14}>
                        <DocumentBox
                          date={e?.issueDate}
                          url={e?.document}
                        />
                      </Col>
                      <Col span={10}>
                        <Row justify={"space-between"} gutter={12}>
                          <Col span={24}>
                            <p className="item">
                              {citizen === "australian"
                                ? "Medical Assessment"
                                : "Medical Assessment"}
                            </p>
                            <p className="value">{e?.medicalAssessment?.name}</p>
                          </Col>
                          <Col span={24} style={{ marginTop: "16px" }}>
                            <p className="item">Issue Date</p>
                            <p className="value">
                              {e?.issueDate
                                ? moment(e?.issueDate).format("DD MMM YYYY")
                                : "----"}
                            </p>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </div>
                </div>
              );
            })}
        </div>
      )}
      {type == "CM" && (
        <Row>
          <Col md={24} className="create_resource table_container">
            <Table
              columns={CommunicationsColumns}
              dataSource={commData}
              pagination={false}
              className="w-100"
              rowKey={"id"}
              loading={loading}
            />
          </Col>
        </Row>
      )}
      {type == "NT" && (
        <Row>
          <Col md={24} className="create_resource table_container">
            <Table
              columns={notificationColumn}
              dataSource={data?.candidate?.notifications}
              pagination={false}
              className="w-100"
              rowKey={"id"}
              loading={loading}
            />
          </Col>
        </Row>
      )}
      {addQualification && (
        <AddQualification
          setAddQualification={setAddQualification}
          addQualification={addQualification}
          qualification={qualification}
          licenceType={licenceType}
          profileId={data?.candidate?._id}
          stateTags={stateTags}
          onSuccess={getData}
          existingQualifications={data?.candidate?.qualifications || []}
          onReplaceQualification={(qual) => {
            setAddQualification(false);
            setQualificationEdit(true);
            setQualificationData(qual);
          }}
        />
      )}
      {addDocument && (
        <AddDocuments
          addDocument={addDocument}
          setAddDocument={setAddDocument}
          classData={classData}
          conditions={conditions}
          idType={idType}
          userId={data?.candidate?.userId}
          stateTags={stateTags}
          visaTypeNo={visaTypeNo}
          medicalAssessmentTypes={medicalAssessmentTypes}
          certifyingAuthority={certifyingAuthority}
          candidateId={data?.candidate?._id || data?._id}
          onDocumentAdded={getData}
        />
      )}
      {addExperience && (
        <AddExperience
          addExperience={addExperience}
          setAddExperience={setAddExperience}
          jobTitle={jobTitle}
          industry={industry}
          discipline={discipline}
          induction={induction}
          skills={skills}
          userId={data?.candidate?.userId}
        />
      )}
      {qualificationEdit && (
        <QualificationEdit
          data={qualificationData}
          qualification={qualification}
          qualificationEdit={qualificationEdit}
          handleQualificationEdit={handleQualificationEdit}
          licenceType={licenceType}
          profileId={data?.candidate?._id}
          stateTags={stateTags}
          existingQualifications={data?.candidate?.qualifications || []}
          onReplaceQualification={(qual) => {
            setQualificationEdit(true);
            setQualificationData(qual);
          }}
        />
      )}
      {otherDetailEdit && (
        <OtherDetailEdit
          data={otherDocumentData}
          citizen={citizen}
          otherDetailEdit={otherDetailEdit}
          handleOtherDetailEdit={handleOtherDetailEdit}
          classData={classData}
          conditions={conditions}
          userId={data?.candidate?.userId}
          stateTags={stateTags}
        />
      )}
      {additionalEdit && (
        <AdditionalDetailEdit
          additionalEdit={additionalEdit}
          setAdditionalEdit={setAdditionalEdit}
          data={data?.candidate?.otherDetails[0]}
          userId={data?.candidate?.userId}
          certifyingAuthority={certifyingAuthority}
          stateTags={stateTags}
          fundName={fundName}
          shirt={shirt}
          pants={pants}
          boots={boots}
        />
      )}
      {medicalAssessmentEdit && (
        <MedicalAssessmentEdit
          data={medicalAssessmentData}
          medicalAssessmentEdit={medicalAssessmentEdit}
          setMedicalAssessmentEdit={setMedicalAssessmentEdit}
          medicalAssessmentTypes={medicalAssessmentTypes}
          onUpdate={getData}
        />
      )}
      {policeClearanceEdit && (
        <PoliceClearanceEdit
          data={policeClearanceData}
          policeClearanceEdit={policeClearanceEdit}
          setPoliceClearanceEdit={setPoliceClearanceEdit}
          certifyingAuthority={certifyingAuthority}
          onUpdate={getData}
        />
      )}
      <Modal
        centered
        footer={false}
        open={resumeEdit}
        title={"Professional Summary Edit"}
        className="resumeModal"
        onCancel={() => setResumeEdit(false)}
      >
        <Form form={resumeForm} layout="vertical" onFinish={onResumeFinish}>
          <Spin spinning={loading} />
          <Row className="containner">
            <Col xs={18}>
              {resumeUpload ? (
                <Upload {...props} onChange={handleResume}>
                  <Button icon={<UploadOutlined />}>Upload</Button>
                </Upload>
              ) : (
                <DocumentBox
                  date={data?.candidate?.resume[0]?.createdAt}
                  url={data?.candidate?.resume[0]?.resume}
                />
              )}
            </Col>
            <Col className="editResume" xs={6}>
              <EditFilled onClick={() => setResumeUpload(true)} />
            </Col>
          </Row>
          <Row className="containner">
            <Col xs={24}>
              <Form.Item 
                label="Profile Summary Description" 
                name="description"
                rules={[
                  {
                    required: true,
                    message: "Please enter profile summary description",
                  },
                ]}
              >
                <TextArea
                  placeholder="Enter summary description"
                  rows={4}
                  maxLength={150}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col xs={24} className="buttonCol">
              <Button className="btn1" htmlType="submit">
                Update
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
    
      <Modal
        title={"Notification"}
        open={notify}
        onCancel={() => {
          form1.resetFields();
          setTicketType(null);
          setTicketId(null);
          setNotify(false);
        }}
        centered
        footer={false}
      >
        <Form 
          form={form1} 
          layout="vertical" 
          onFinish={handleNotify}
        >
          <Row>
            <Col xs={24}>
              <Form.Item name="message">
                <Input className="input" placeholder="Enter message" />
              </Form.Item>
              <Col md={24} className="buttonCol">
                <Form.Item>
                  <Button
                    className="btn"
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                  >
                    Save
                  </Button>
                </Form.Item>
              </Col>
            </Col>
          </Row>
        </Form>
      </Modal>

      <Modal
        className="candidateDeleteModal"
        centered
        onCancel={() => {
          setVisible(false);
        }}
        open={visible}
        footer={null}
        title={`Verify Document?`}
      >
        <Row className="header">
          <Col>
            <p className="desc">
              Are you sure you want to verify the document?
            </p>
          </Col>
        </Row>

        <Row align={"middle"} gutter={16} justify={"end"}>
          <Col>
            <Button
              className="confirmBtn"
              onClick={() => handleVerifyByModal()}
              loading={loading}
            >
              Okay
            </Button>
          </Col>
          <Col>
            <Button
              className="cancelBtn"
              onClick={() => {
                setVisible(false);
              }}
            >
              Cancel
            </Button>
          </Col>
        </Row>
      </Modal>
      <Modal
        className="candidateDeleteModal"
        centered
        onCancel={() => {
          setDeleteModalVisible(false);
          setDeleteType(null);
          setDeleteItemId(null);
          setDeleteCandidateId(null);
          setDeleteUserId(null);
          setDeleteIsVisa(false);
        }}
        open={deleteModalVisible}
        footer={null}
        title={`Delete ${deleteType === "qualification" ? "Qualification" : deleteType === "document" ? (deleteIsVisa ? "VISA" : "Document") : deleteType === "medical" ? "Medical Assessment" : deleteType === "policeClearance" ? "Police Clearance" : "Experience"}?`}
      >
        <Row className="header">
          <Col>
            <p className="desc">
              Are you sure you want to delete this {deleteType === "qualification" ? "qualification" : deleteType === "document" ? (deleteIsVisa ? "VISA" : "document") : deleteType === "medical" ? "medical assessment" : deleteType === "policeClearance" ? "police clearance" : "experience"}?
            </p>
          </Col>
        </Row>

        <Row align={"middle"} gutter={16} justify={"end"}>
          <Col>
            <Button
              className="confirmBtn"
              onClick={async () => {
                try {
                  setLoading(true);
                  if (deleteType === "qualification") {
                    await API_MANAGER.deleteCandidateQualification(
                      deleteItemId,
                      deleteCandidateId
                    );
                    message.success("Qualification deleted successfully");
                  } else if (deleteType === "document") {
                    if (deleteIsVisa) {
                      const candidateId = data?.candidate?._id || data?._id;
                      await API_MANAGER.editCandidateVisa(
                        { isAustralian: true },
                        candidateId
                      );
                      setCitizen("australian");
                      message.success("VISA deleted successfully");
                    } else {
                      await API_MANAGER.deleteCandidateDocument(
                        deleteItemId,
                        deleteUserId
                      );
                      message.success("Document deleted successfully");
                    }
                  } else if (deleteType === "medical") {
                    await API_MANAGER.deleteCandidateMedical(
                      deleteItemId,
                      deleteUserId
                    );
                    message.success("Medical assessment deleted successfully");
                  } else if (deleteType === "policeClearance") {
                    await API_MANAGER.editCandidateAdditionalDetails({
                      userId: deleteUserId,
                      hasPoliceClearance: false,
                      policeClearanceDetails: null,
                    });
                    message.success("Police clearance deleted successfully");
                  }
                  setDeleteModalVisible(false);
                  setDeleteType(null);
                  setDeleteItemId(null);
                  setDeleteCandidateId(null);
                  setDeleteUserId(null);
                  setDeleteIsVisa(false);
                  getData();
                } catch (error) {
                  message.error(
                    error?.response?.data?.message?.message || `Failed to delete ${deleteType}`
                  );
                } finally {
                  setLoading(false);
                }
              }}
              loading={loading}
            >
              Delete
            </Button>
          </Col>
          <Col>
            <Button
              className="cancelBtn"
              onClick={() => {
                setDeleteModalVisible(false);
                setDeleteType(null);
                setDeleteItemId(null);
                setDeleteCandidateId(null);
                setDeleteUserId(null);
                setDeleteIsVisa(false);
              }}
            >
              Cancel
            </Button>
          </Col>
        </Row>
      </Modal>
      <Modal
        centered
        open={citizenshipEditModalVisible}
        onCancel={() => {
          setCitizenshipEditModalVisible(false);
          setSelectedCitizenship(null);
        }}
        footer={null}
        title="Edit Citizenship Status"
      >
        <div style={{ padding: "20px 0" }}>
          <p style={{ marginBottom: "20px", fontSize: "16px" }}>
            Are you sure you want to change the citizenship status?
          </p>
          <Row gutter={16} style={{ marginBottom: "20px" }}>
            <Col span={24}>
              <Radio.Group
                value={selectedCitizenship}
                onChange={(e) => setSelectedCitizenship(e.target.value)}
                style={{ width: "100%" }}
              >
                <Radio value="australian">Australian</Radio>
                <Radio value="non_australian">Non-Australian</Radio>
              </Radio.Group>
            </Col>
          </Row>
          <Row gutter={16} justify="end">
            <Col>
              <Button
                onClick={() => {
                  setCitizenshipEditModalVisible(false);
                  setSelectedCitizenship(null);
                }}
              >
                Cancel
              </Button>
            </Col>
            <Col>
              <Button
                type="primary"
                loading={loading}
                onClick={async () => {
                  try {
                    setLoading(true);
                    const isAustralian = selectedCitizenship === "australian";
                    const candidateId = data?.candidate?._id || data?._id;
                    if (!candidateId) {
                      throw new Error("Candidate ID not found");
                    }
                    
                    await API_MANAGER.editCandidateVisa(
                      { 
                        isAustralian
                      },
                      candidateId
                    );
                    message.success("Citizenship status updated successfully");
                    setCitizenshipEditModalVisible(false);
                    setSelectedCitizenship(null);
                    setCitizen(selectedCitizenship);
                    getData(); // Refresh data to reflect changes
                  } catch (error) {
                    console.error("Citizenship update error:", error);
                    const errorMessage = error?.response?.data?.message?.message 
                      || error?.response?.data?.message
                      || error?.message 
                      || "Failed to update citizenship status. Please try again.";
                    message.error(errorMessage);
                  } finally {
                    setLoading(false);
                  }
                }}
              >
                Update
              </Button>
            </Col>
          </Row>
        </div>
      </Modal>
    </>
  );
}
export default CandidateEdit;

